import { QueryClientProvider } from 'react-query';
import { queryClient } from '../services/queryClient';
import { ReactQueryDevtools } from 'react-query/devtools';
import { GoogleOAuthProvider } from '@react-oauth/google';
import config from "../config";

export const Providers = ({ children }) => {
  return (
    <GoogleOAuthProvider clientId={config.googleClientIdFallback}>
      <QueryClientProvider client={queryClient}>
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
        <>{children}</>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
};
